import {
  Button,
  Colors,
  Cross,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import { _route } from '../../routes/config'
import styles from './style.module.scss'

interface IProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

interface IState {}

export class WelcomeModal extends React.Component<IProps, IState> {
  onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  setActive = (status: boolean) => {
    if (!status) {
      const { onClose } = this.props
      window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
      // window.history.back()
      onClose()
    }
  }

  render() {
    const { open, onSubmit } = this.props

    return (
      <Modal
        active={open}
        setActive={this.setActive}
        x={<Cross color={Colors.unselected} size="big" />}
        baseClassName={styles.wrap}
      >
        <Typography type="title" size="big">
          Welcome to your parent interface
          <span style={{ color: Colors.redAccent, fontStyle: 'italic' }}>
            !
          </span>
        </Typography>
        <Typography type="text">
          This is where you will manage your children’s profiles, monitor their
          evaluation progress, view their evaluation results, and go over
          personalized suggestions that will be provided for them
        </Typography>
        <Button type="max" color="pink" onClick={onSubmit}>
          Create Child Profile
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WelcomeModal/index.tsx